export default "__VITE_ASSET__2fea9c1a__"